import React from 'react';
import MessengerPanel from '../../../../../MessengerConfig/components/MessengerPanel';

const MessengerDetail = ({ agentId }) => {
  return (
    <div style={{ padding: '1rem' }}>
      <MessengerPanel agentId={agentId} />
    </div>
  );
};

export default MessengerDetail;
